import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Label,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import CreateBloc from "./Blocs/CreateBloc";
import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import moment from "moment";

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(),
    years = [];
  startYear = startYear || 1980;
  while (startYear <= currentYear) {
    var newObj = {};
    var year = startYear++;
    newObj["label"] = year;
    newObj["value"] = year;
    years.push(newObj);
  }
  return years;
};

const createMonthOptions = () => {
  var months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  return months.map(function (month, i) {
    var newObj = {};
    newObj["label"] = month;
    newObj["value"] = ++i;

    return newObj;
  });
};

class IndexView extends Component {
  createBloc = new CreateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      yearOptions: createYearOption(new Date().getFullYear() - 30),
      monthOptions: createMonthOptions(),
    };
  }

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];

      return newObj;
    });
  };

  dateParse = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, ""); // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.createBloc.fetchCreate(formData);
    console.log(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState({
              loading: false,
              success: true,
            });
          } else {
            this.setState({
              loading: false,
              message: result.data.message,
              failed: true,
            });
          }

          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.createBloc.createChannel.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>Tambah Periode Calon PPPK</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tahun <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <CustomSelect
                          name="cp3k_period_year"
                          errorMessage="Pilih Tahun"
                          options={this.state.yearOptions}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Tahun"
                          defaultValue={new Date().getFullYear()}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Bulan <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <CustomSelect
                          name="cp3k_period_month"
                          errorMessage="Pilih Bulan"
                          options={this.state.monthOptions}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Bulan"
                          defaultValue={new Date().getMonth() + 1}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Keterangan
                      </label>
                      <Col md="4">
                        <AvField
                          name="cp3k_period_description"
                          id="cp3k_period_description"
                          placeholder="Keterangan"
                          type="textarea"
                          errorMessage="Masukan Keterangan"
                          className="form-control"
                          validate={{ required: { value: false } }}
                        />
                      </Col>
                    </Row>

                    <Row style={{ marginBottom: 100 }}>
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/kepegawaian/cp3k.html">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo={this.state.message ?? "Data gagal disimpan"}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? <Redirect to="/kepegawaian/cp3k.html" /> : null}
      </Fragment>
    );
  }
}

export default IndexView;
